/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type { NotifyAccountantsRequest } from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiAccountingSetupController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-accounting-setup-controller
   * @name NotifyAccountants
   * @request POST:/api/v1/accounting-setup/notify-accountant
   */
  notifyAccountants = (data: NotifyAccountantsRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/accounting-setup/notify-accountant`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static notifyAccountantsPath = '/v1/accounting-setup/notify-accountant'
  static notifyAccountantsMethod = 'POST'
}
